import React, { useEffect } from 'react';
import { CUSTOMER_DATA_KEY, GetSoDto, SoDataInput, useGeneralSoContext } from 'src/common';
import { useSessionStorage } from 'src/common/hooks';
import { CustomerForm, CustomerFormData } from 'src/components/forms/customer.form';
import { NavigationService } from 'src/common/utils/navigation.util';
import { AppRoutes } from './_router/app.routes';
import { useGetSo } from 'src/common/api/apollo/queries/useGetSo.query';
import { ContainerComponent, Flex, FormDisclaimer, FormRef, LoaderSquare, NavigationButtons, StepHeader } from 'src/components';
import { Helmet } from 'react-helmet-async';

export const CustomerWebshopPage: React.FC = () => {
  const formRef = React.useRef<FormRef>(null);
  const { so, refetch, loading } = useGetSo();
  const { soInitialData, setSoInitialData } = useGeneralSoContext();
  const { setValue: setCustomerData, getValue: getCustomerData } = useSessionStorage<SoDataInput>(CUSTOMER_DATA_KEY);

  useEffect(() => {
    if (so) {
      refetch();
    }
  }, []);

  const handleBack = () => {
    NavigationService.navigate(AppRoutes.WEBSHOP.PROPERTY_INFO);
  };

  const handleFormSubmit = async (values: CustomerFormData) => {
    const data: SoDataInput = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      phone: values.phoneNumber,
    };

    setCustomerData(data);
    setSoInitialData({ ...soInitialData, data });

    NavigationService.navigate(AppRoutes.WEBSHOP.RISKS);
  };

  const modelToForm = (so?: GetSoDto): CustomerFormData => {
    const stored = getCustomerData();
    return {
      firstName: stored?.firstName || so?.data?.firstName || '',
      lastName: stored?.lastName || so?.data?.lastName || '',
      email: stored?.email || so?.data?.email || '',
      phoneNumber: stored?.phone || so?.data?.phone || '',
    };
  };

  const formData = modelToForm(so || undefined);

  if (loading) return (
    <ContainerComponent>
      <Flex align="center" justify="center" style={{ height: '40vh' }}>
        <LoaderSquare/>
      </Flex>
    </ContainerComponent>
  );

  return (
    <ContainerComponent>
      <Helmet>
        <title>Tvoji podaci | Osiguranje imovine - kompare.hr</title>
      </Helmet>
      <StepHeader/>
      <CustomerForm
        ref={formRef}
        data={formData}
        onSubmit={handleFormSubmit}
      />
      <NavigationButtons
        handleBack={handleBack}
        handleNext={() => formRef.current?.submitForm?.()}
      />
      <FormDisclaimer/>
    </ContainerComponent>
  );
};

export default CustomerWebshopPage;
